import React, { useState, useEffect, useMemo } from 'react';
import { Card, Tabs } from 'antd';
import { useSearchParams } from 'react-router-dom';
import DepartmentList from './DepartmentList';
import RoleList from './RoleList';
import roleService, { ROLES } from '../../service/RoleService';

const DepartmentSettings = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const canManageDepartmentSettings = roleService.hasRole(ROLES.ROLE_HR) && roleService.hasRole(ROLES.ROLE_ACCESS_ALL_OFFICE);
    const availableTabs = useMemo(
        () => (canManageDepartmentSettings ? ['departments', 'roles'] : ['roles']),
        [canManageDepartmentSettings]
    );
    const tabParam = searchParams.get('tab') || (canManageDepartmentSettings ? 'departments' : 'roles');
    const [activeTab, setActiveTab] = useState(tabParam);

    // Sync activeTab with URL parameter
    useEffect(() => {
        const tab = searchParams.get('tab');
        if (tab && availableTabs.includes(tab)) {
            setActiveTab(tab);
        } else if (!availableTabs.includes(activeTab)) {
            setActiveTab(availableTabs[0]);
        }
    }, [searchParams, availableTabs, activeTab]);

    const handleTabChange = (key) => {
        setActiveTab(key);
        setSearchParams({ tab: key });
    };

    const tabs = [
        canManageDepartmentSettings ? {
            key: 'departments',
            label: 'Departments',
            children: <DepartmentList />
        } : null,
        {
            key: 'roles',
            label: 'Billable Rate Card',
            children: <RoleList />
        }
    ].filter(Boolean);

    return (
        <div className="wrapper-grey finance-container">
            <Card>
                <Tabs
                    activeKey={activeTab}
                    onChange={handleTabChange}
                    items={tabs}
                />
            </Card>
        </div>
    );
};

export default DepartmentSettings;
